export default {
  nameLenthBeyond: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000194","名称的长度不能超过限制(4个字符)") /* "名称的长度不能超过限制(4个字符)" */
};
